// Angular imports
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

// 3rd party imports
import { DxValidationGroupComponent } from 'devextreme-angular';

// CC-Common imports
import { IconConstants } from '@therealmanage/ciranet-ui-common';
import { RecaptchaBaseComponent } from '../../_base/recaptcha-base.component';
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

// Service imports
import { EnvironmentConfigService } from '../../_services/environment-config.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { ResultStatusDto } from '../../_models/result-status-dto';
import { GenerateValidateEmailParameterDto } from '../../_models/generate-validate-email-parameter-dto';

@Component({
  selector: 'app-resend-validation-email',
  templateUrl: './resend-validation-email.component.html',
  styleUrls: ['./resend-validation-email.component.scss'],
  standalone: false
})
export class ResendValidationEmailComponent
  extends RecaptchaBaseComponent
  implements OnInit
{
  @ViewChild('validatorResendEmail', { static: false })
  validatorResendEmail: DxValidationGroupComponent;

  isSmallScreen = false;
  email = '';
  loadingVisible = false;
  errorMessage = '';

  backToLoginIcon = IconConstants.BACK_TO_LOGIN;
  resetIcon = IconConstants.RESET;

  constructor(
    private router: Router,
    private userService: UserService,
    private screenService: ScreenService,
    protected override errorService: ServerErrorService,
    protected override envConfig: EnvironmentConfigService
  ) {
    super(errorService, envConfig);
  }

  ngOnInit() {
    this.updateScreenSize();
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreenSize()
    );
  }

  resendValidationEmail(): void {
    const validator = this.validatorResendEmail.instance.validate();
    if (validator.isValid && this.isValidRecaptcha()) {
      this.loadingVisible = true;
      const dto = new GenerateValidateEmailParameterDto();
      dto.email = this.email;
      dto.recaptchaToken = this.recaptchaToken;

      RxjsUtils.safeSubscribe(
        this.userService.generateValidationEmail(dto),
        (data: ResultStatusDto) => {
          this.resetRecaptcha();
          this.loadingVisible = false;
          this.errorMessage = data.message;
          if (data.isSuccess) {
            this.messageBox.showSuccessMessage(
              'Result',
              'An email with instructions to validate your email address has been sent. Please check your email.'
            );
          } else {
            this.messageBox.showErrorMessage(
              'Error',
              "<div style='color: red;'>Couldn't send validation email. Please contact customer support.</div>"
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.resetRecaptcha();
          this.loadingVisible = false;
          this.processApiError(error);
        }
      );
    }
  }

  backToLogin(): void {
    this.router.navigate(['user', 'login']);
  }

  private updateScreenSize(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }
}
